import { BSC_RPC_URL } from '@/constants/bsc'
import { CHAIN_CONFIG } from '@/lib/api/relay'
import { BSC_USDT_ADDRESS } from '@/lib/predictfun/client'
import { readEthersErc20Balance } from '../evm'
import type { MarketBalance, MarketWalletProvider } from '../types'

export const predictfunWalletProvider: MarketWalletProvider = {
	id: 'predictfun',
	label: 'Predict.fun',
	direction: 'toPredictfun',
	decimals: 18,
	chain: { chainId: CHAIN_CONFIG.bsc.id, currency: CHAIN_CONFIG.bsc.usdt },
	cashToken: {
		symbol: 'USDT',
		address: BSC_USDT_ADDRESS,
		decimals: 18,
	},
	resolveAddress: runtime =>
		runtime.addressOverrides?.predictfun ?? runtime.eoaAddress ?? undefined,
	balanceQueryKey: address => ['market-balance', 'predictfun', address] as const,
	async readBalance(runtime): Promise<MarketBalance | null> {
		const address = this.resolveAddress(runtime)
		if (!address) return null

		const cash = await readEthersErc20Balance({
			rpcUrl: BSC_RPC_URL,
			tokenAddress: BSC_USDT_ADDRESS,
			account: address,
			decimals: 18,
			symbol: 'USDT',
		})

		return { platform: 'predictfun', address, cash }
	},
}
